module.exports = __webpack_public_path__ + "img/m249.168ccc22.svg";